<div *ngIf="holidays">
  <p>{{ 'HOLIDAY_OPENING_HOURS_EXPLANATION_PART_1' | translate }}</p>

  <div class="row">
    <div class="col-12" *ngIf="holidays && holidays.length > 0">
      <button class="btn-bulk-action btn btn-info" (click)="setAllClosed()">
        {{ 'HOLIDAY_BULK_ACTION_CLOSED' | translate }}
      </button>
      <button class="btn-bulk-action btn btn-info" (click)="setAllOpenAsNormal()">
        {{ 'HOLIDAY_BULK_ACTION_OPEN_AS_NORMAL' | translate }}
      </button>
      <button class="btn-bulk-action btn btn-info" (click)="setAllOpen24Hours()">
        {{ 'HOLIDAY_BULK_ACTION_OPEN_24_HOURS' | translate }}
      </button>
    </div>

    <div class="col-12 text-center" *ngIf="!holidays || holidays.length === 0">
      <hr />
      <span>{{ 'NO_HOLIDAYS_AVAILABLE' | translate }} ({{ country | uppercase }})</span>
    </div>

    <lh-opening-hours-picker
      *ngFor="let h of holidays"
      class="col-12"
      [(openingHours)]="h.openingHours"
      [allowInherit]="true"
      [heading]="getHeading(h.holiday)"
      [description]="getDescription(h.holiday)"
      (openingHoursChange)="onChange($event)"
    >
    </lh-opening-hours-picker>
  </div>
</div>
